import { Col } from "react-bootstrap";

export const ProjectCard = ({
  title,
  description,
  imgUrl,
  liveLink,
  githubLink,
  serverLink,
}) => {
  return (
    <Col size={12} sm={6} md={4} className="h-full">
      <div className="proj-imgbx">
        <img src={imgUrl} />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <br />
          <div className="d-flex justify-content-between mt-auto text-white px-3">
            <a
              className="nav-link btn border text-white"
              href={liveLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              Link Site
            </a>
            <a
              className="nav-link btn border text-white"
              href={githubLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              Client Code
            </a>
            <a
              className="nav-link btn border text-white"
              href={serverLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              Server Code
            </a>
          </div>
        </div>
      </div>
    </Col>
  );
};
